export type Mode = "create" | "edit" | "view";

export interface Permissions {
  canEdit: boolean;
  canDelete: boolean;
  canSubmit: boolean;
}

export interface PageInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
}

export interface PagedResponse<T> {
  items: T[];
  pageInfo: PageInfo;
}

export interface PaginationQuery {
  page: number;
  size: number;
  sortBy?: string;
  direction?: "ASC" | "DESC";
}

export interface SearchQuery<T> extends PaginationQuery {
  conditions?: T;
}

export const defaultPaginationQuery: PaginationQuery = {
  page: 0,
  size: 25,
  sortBy: "createdAt",
  direction: "DESC",
};

export interface SelectType {
  value: string;
  label: string;
}

export interface CodeValue {
  id: number;
  code?: string;
  label: string;
}

export interface CodeValues extends Record<KnownCodeKeys, CodeValue[]> {
  [key: string]: CodeValue[]; // 동적 키 허용
}

// 기존에 알려진 키들에 대한 타입 힌트 추가
export type KnownCodeKeys = "INSTRUCTION_TYPE" | "INSTRUCTION_STATUS" | "INSTRUCTION_STATUS_TRANSITION";

// 특정 키에 대한 타입 가드
export const isKnownCodeKey = (key: string): key is KnownCodeKeys => {
  return [
    "INSTRUCTION_TYPE", // 지시유형
    "INSTRUCTION_STATUS", // 지시상태
    "INSTRUCTION_STATUS_TRANSITION", // 지시상태 전환
  ].includes(key);
};

export const SUBMIT_TYPE = {
  SAVE: "SAVE",
  REGISTRATION_REQUESTED: "REGISTRATION_REQUESTED",
};

export const TOPBAR_HEIGHT = 64;
export const SIDEBAR_WIDTH = 280;
export const START_YEAR = 2025;

// 파일 업로드 설정
export interface FileSettings {
  accept: Record<string, string[]>;
  maxSize: number;
  maxCount: number;
  maxTotalCount: number;
}

export interface AppSettings {
  file: FileSettings;
}

// 기본 파일 설정 (API 로딩 실패 시 폴백)
export const DEFAULT_FILE_SETTINGS: FileSettings = {
  accept: {
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "application/pdf": [".pdf"],
  },
  maxSize: 10485760, // 10MB
  maxCount: 3,
  maxTotalCount: 6,
};
